/**
 * The email and ISO datetime patterns zod 4.4 validated with, passed explicitly so a zod
 * upgrade cannot narrow what the API accepts. zod 4.5 stopped accepting a datetime without
 * seconds ("2026-10-24T10:30Z") and 4.6 rewrote the email pattern; both are frozen by the
 * public API v1 contract (docs/public-api-mcp-contract.md) and relied on by shipped mobile
 * builds. Every `z.email()`, `.email()`, `z.iso.datetime()` and `.datetime()` takes one of
 * these; tests/unit/schema-formats.test.ts fails a call site that does not.
 */

/** zod 4.4's `z.regexes.email`. */
export const EMAIL_PATTERN =
  /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;

const DATE_SOURCE =
  '(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))';

/** zod 4.4's `z.regexes.datetime`: seconds and fractions optional, `Z` always accepted. */
export function dateTimePattern(options: { offset?: boolean; local?: boolean } = {}): RegExp {
  const zones = ['Z'];
  if (options.local) zones.push('');
  if (options.offset) zones.push('([+-](?:[01]\\d|2[0-3]):[0-5]\\d)');
  const time = `(?:[01]\\d|2[0-3]):[0-5]\\d(?::[0-5]\\d(?:\\.\\d+)?)?`;
  return new RegExp(`^${DATE_SOURCE}T(?:${time}(?:${zones.join('|')}))$`);
}

/** Params for `z.email()` / `.email()`. */
export const emailFormat = (message?: string) => ({ message, pattern: EMAIL_PATTERN });

/** Params for `z.iso.datetime()` / `.datetime()`. */
export const dateTimeFormat = (options: { offset?: boolean; local?: boolean; message?: string } = {}) => ({
  ...options,
  pattern: dateTimePattern(options),
});
